import { render, staticRenderFns } from "./UserEvaluationComponent.vue?vue&type=template&id=2e33c886&scoped=true&"
import script from "./UserEvaluationComponent.vue?vue&type=script&lang=js&"
export * from "./UserEvaluationComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserEvaluationComponent.vue?vue&type=style&index=0&id=2e33c886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33c886",
  null
  
)

export default component.exports